import { create } from 'zustand';

const ADMIN_EMAIL = import.meta.env.VITE_ADMIN_EMAIL;
const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD;

const useAuthStore = create((set) => ({
  isAuthenticated: Boolean(localStorage.getItem('mesum_admin_authed')),
  login: (email, password) => {
    const ok = email === ADMIN_EMAIL && password === ADMIN_PASSWORD;
    if (ok) {
      localStorage.setItem('mesum_admin_authed', '1');
      set({ isAuthenticated: true });
      return true;
    }
    return false;
  },
  logout: () => {
    localStorage.removeItem('mesum_admin_authed');
    set({ isAuthenticated: false });
  }
}));

export default useAuthStore;


